import { MyLiNKQueryKeys } from "constants/my-link-query-keys";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import { useQuery } from "react-query";
import { t } from "utilities/localization-utils";
import UserBookmarkCountService, {
    UserBookmarkCountListQueryParams,
} from "utilities/services/user-bookmarks/count/user-bookmark-count-service";
import { ToastManager } from "utilities/toast/toast-manager";
export interface BookmarkQueryResponse {
    bookmarks: UserBookmarkRecord[];
    bookmarksLength: number;
}

export default function useBookmarkGroups(
    countBy: UserBookmarkCountBy,
    options?: UserBookmarkCountListQueryParams
) {
    const {
        data: bookmarkGroups,
        isLoading: isLoadingCounts,
        refetch: refetchBookmarkGroups,
    } = useQuery({
        queryKey: [
            `${MyLiNKQueryKeys.BookmarkCountBy}_${countBy}`,
            options?.bookmarksCreatedByMe,
            options?.collectionShareType,
            options?.searchText,
            options?.sortOption,
        ],
        queryFn: async () =>
            await fetchBookmarkCounts(
                countBy,
                options as UserBookmarkCountListQueryParams
            ),
        keepPreviousData: true,
    });

    return { bookmarkGroups, isLoadingCounts, refetchBookmarkGroups };
}

const fetchBookmarkCounts = async (
    countBy: UserBookmarkCountBy,
    options: UserBookmarkCountListQueryParams
) => {
    try {
        const result = await UserBookmarkCountService.list({
            ...options,
            countBy: countBy,
            sortOption: options.sortOption,
        });

        if (result.result?.hasErrors()) {
            throw new Error();
        }
        return result.resultObjects;
    } catch (err) {
        ToastManager.error(
            t("errors-actionResource", {
                action: t("loading"),
                resource: t("bookmark_plural"),
            })
        );
    }
};
